<template>
  <div>
    <delegation-rate-menu />

    <v-row class="mb-3">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <group-delegation-form-dialog :id="null" @saved="loadList">
          <v-btn block color="accent">{{ $t("settings.delegationRate.groupDelegationRate.addNewGroup") }}</v-btn>
        </group-delegation-form-dialog>
      </div>
    </v-row>

    <v-data-table :headers="headers" :items="groupList" :search="search">
      <template #item="props">
        <tr>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">{{ props.item.description }}</td>
          <td class="text-left">{{ props.item.count_rates }}</td>
          <td class="text-left">
            {{ props.item.parent_group_name.length == 0 ? $t("settings.delegationRate.customDelegationRate.systemSettings") : props.item.parent_group_name }}
          </td>
          <td class="text-left">
            {{ props.item.count_users }}
            <span v-if="props.item.child_group_names !== null">
              {{ $t("settings.delegationRate.groupDelegationRate.usersAndChildGroups") }}: {{ props.item.child_group_names }}</span
            >
          </td>
          <td class="text-center text-no-wrap">
            <group-delegation-form-dialog :id="props.item.id" @saved="loadList"> </group-delegation-form-dialog>

            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :disabled="!canBeDeleted(props.item)" @click.native="remove(props.item)" icon v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span v-if="!canBeDeleted(props.item)">{{ $t("settings.delegationRate.groupDelegationRate.detachChildFirst") }}</span>
              <span v-else>{{ $t("global.delete") }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-alert type="info">{{ $t("settings.delegationRate.groupDelegationRate.addUserInfo") }}</v-alert>
  </div>
</template>

<script>
import DelegationRateMenu from "../../../components/Settings/DelegationRate/DelegationRateMenu.vue";
import GroupDelegationFormDialog from "../../../components/Settings/DelegationRate/GroupDelegationFormDialog.vue";

export default {
  name: "SettingsDelegationRateGroup",
  components: { GroupDelegationFormDialog, DelegationRateMenu },
  data: () => ({
    groupList: [],
    search: null
  }),
  created() {
    this.loadList();
  },
  computed: {
    headers() {
      return [
        { text: this.$t("global.name"), value: "name" },
        { text: this.$t("global.description"), value: "description" },
        {
          text: this.$t("settings.delegationRate.customDelegationRate.specialRates"),
          value: "count_rates"
        },
        {
          text: this.$t("settings.delegationRate.customDelegationRate.inheritFrom"),
          value: "parent_group_name"
        },
        {
          text: this.$t("settings.delegationRate.customDelegationRate.users"),
          value: "count_users"
        },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  methods: {
    canBeDeleted(item) {
      return item.child_group_names === null;
    },
    remove(item) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("settings.delegationRate.groupDelegationRate.groupDeleteDialog.content"),
          title: this.$t("settings.delegationRate.groupDelegationRate.groupDeleteDialog.title")
        })
        .then(() => {
          this.axios.post("settings/delegation-group/delete", { id: item.id }).then(() => {
            this.loadList();
            this.$store.dispatch("snackbarPush", {
              text: this.$t("settings.delegationRate.groupDelegationRate.groupDeleteDialog.snackbar"),
              color: "error",
              position: "down"
            });
          });
        });
    },
    loadList() {
      this.axios.get("settings/delegation-group/list").then(resp => {
        this.groupList = resp.data;
      });
    }
  }
};
</script>

<style scoped></style>
